import { z } from "zod";

const nameSchema = (fieldName: string) =>
  z
    .string()
    .trim()
    .min(1, `${fieldName} is required`)
    .max(50, `${fieldName} cannot exceed 50 characters`)
    .regex(
      /^[A-Za-z]+(?: [A-Za-z]+)*$/,
      `${fieldName} can only contain letters and spaces`,
    );

export const applicationSchema = z.object({
  firstName: nameSchema("First name"),

  lastName: nameSchema("Last name"),

  myKadPassport: z
    .string()
    .trim()
    .transform((value) =>
      value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase(),
    )
    .refine(
      (value) => {
        if (!value) return true;

        // MyKad: numbers only, maximum 12 digits
        if (/^\d+$/.test(value)) {
          return value.length <= 12;
        }

        // Passport: letters and numbers, maximum 15 characters
        return /^[A-Z0-9]+$/.test(value) && value.length <= 15;
      },
      {
        message:
          "MyKad must be maximum 12 digits or passport maximum 15 characters",
      },
    ),

  phoneNumber: z
    .string()
    .trim()
    .max(15, "Phone number cannot exceed 15 digits")
    .refine(
      (value) => !value || /^\d+$/.test(value),
      "Phone number can only contain numbers",
    ),

  categoryKey: z
    .string()
    .trim()
    .min(1, "Sila pilih kategori")
    .refine(
      (value) => value === "resident" || value === "non-resident",
      { message: "Sila pilih kategori" },
    ),

  kampung: z
    .number({
      message: "Sila pilih kampung",
    })
    .min(1, "Sila pilih kampung"),

  address1: z
    .string()
    .trim()
    .min(1, "Address 1 is required"),

  address2: z.string().trim().nullable().optional(),
});

export type EditApplicationFormValues = z.infer<
  typeof applicationSchema
>;